import React, { PureComponent } from "react";
import { connect } from "react-redux";
import PhoneInfoBar from "../components/PhoneInfoBar";
import { updateFilter } from "../actions/filter";
import { updateCollapsible } from "../actions/componentStatus/collapsibles";
import {
  findPortalDataEntity,
  phoneVariantIdsForPhoneId
} from "../lib/portalData";
import { SORTS } from "../constants/sorts";
import { updateSort } from "../actions/sort";
import { OFFER_TYPES } from "../constants/offerTypes";

const mobilePhoneVariantAndMemorySelectorCollapsibleId =
  "mobilePhoneVariantAndMemorySelector";

class PhoneInfoBarContainer extends PureComponent {
  render() {
    const {
      filter,
      mobilePhoneVariantAndMemorySelectorCollapsed,
      offerType,
      portalData,
      updateFilterPhoneId,
      updateFilterPhoneVariantId,
      updateMobilePhoneVariantAndMemorySelectorCollapsed
    } = this.props;

    return (
      <PhoneInfoBar
        filter={filter}
        mobilePhoneVariantAndMemorySelectorCollapsed={
          mobilePhoneVariantAndMemorySelectorCollapsed
        }
        offerType={offerType}
        onMobilePhoneVariantAndMemorySelectorClick={
          updateMobilePhoneVariantAndMemorySelectorCollapsed
        }
        portalData={portalData}
        updateFilterPhoneId={updateFilterPhoneId}
        updateFilterPhoneVariantId={updateFilterPhoneVariantId}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    clientConfig: state.clientConfig,
    filter: state.filter[state.offerType],
    mobilePhoneVariantAndMemorySelectorCollapsed:
      state.componentStatus.collapsibles[
        mobilePhoneVariantAndMemorySelectorCollapsibleId
      ],
    offerType: state.offerType,
    portalData: state.portalData
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateFilter: (offerType, filter) => {
      dispatch(updateFilter(offerType, filter));
    },
    updateMobilePhoneVariantAndMemorySelectorCollapsed: collapsed => {
      dispatch(
        updateCollapsible(
          mobilePhoneVariantAndMemorySelectorCollapsibleId,
          collapsed
        )
      );
    },
    updateSort: (offerType, sort) => {
      dispatch(updateSort(offerType, sort));
    }
  };
}

function mergeProps(stateProps, dispatchProps, ownProps) {
  const {
    updateFilter,
    updateMobilePhoneVariantAndMemorySelectorCollapsed,
    updateSort
  } = dispatchProps;
  const {
    clientConfig,
    portalData,
    mobilePhoneVariantAndMemorySelectorCollapsed,
    offerType
  } = stateProps;

  function updateFilterPhoneId(phoneId) {
    const phone = findPortalDataEntity(portalData, "phone", phoneId);
    if (phone != null) {
      const phoneCategory = findPortalDataEntity(
        portalData,
        "phoneCategory",
        phone.phoneCategory.id
      );

      let maxPrice;
      if (offerType === OFFER_TYPES.phoneOffer || phoneCategory == null) {
        maxPrice = clientConfig.widgetOptions[offerType].initialFilter.maxPrice;
      } else {
        maxPrice = phoneCategory.maxPrice;
      }

      updateSort(offerType, SORTS.bestTco);
      updateFilter(offerType, {
        brandId: [],
        maxPrice: maxPrice,
        phoneId: [phoneId],
        phoneVariantId: phoneVariantIdsForPhoneId(
          portalData,
          offerType,
          phoneId
        )
      });
    }
  }

  function updateFilterPhoneVariantId(phoneVariantId) {
    updateSort(offerType, SORTS.bestTco);
    updateFilter(offerType, {
      brandId: [],
      phoneId: [],
      phoneVariantId: [phoneVariantId]
    });
  }

  return {
    ...stateProps,
    ...ownProps,
    updateFilterPhoneId: phoneId => updateFilterPhoneId(phoneId),
    updateFilterPhoneVariantId: phoneVariantId =>
      updateFilterPhoneVariantId(phoneVariantId),
    updateMobilePhoneVariantAndMemorySelectorCollapsed: () => {
      let newValue;
      if (mobilePhoneVariantAndMemorySelectorCollapsed == null) {
        newValue = true;
      } else {
        newValue = !mobilePhoneVariantAndMemorySelectorCollapsed;
      }

      updateMobilePhoneVariantAndMemorySelectorCollapsed(newValue);
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(PhoneInfoBarContainer);
